import { render } from "./BulkActionCheckin.vue?vue&type=template&id=b2cb388e"
import script from "./BulkActionCheckin.vue?vue&type=script&lang=js"
export * from "./BulkActionCheckin.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__